import React from 'react'
import classNames from 'classnames'

const Burger = ({ active = false }) => {
  return (
    <div className={classNames('burger', active && 'active')}>
      <div className="stroke top" />
      <div className="stroke middle" />
      <div className="stroke bottom" />
    </div>
  )
}

export default Burger
